import { motion } from "framer-motion";

export default function Breadcrumb({ items = [], onNavigate = () => {} }) {
  const isEmpty = items.length === 0;

  return (
    <nav className="text-sm text-gray-600 mb-5" aria-label="Breadcrumb">
      <ol className="flex items-center flex-wrap">
        {isEmpty ? (
          <li className="text-primary font-semibold">Home</li>
        ) : (
          items.map((item, index) => {
            const isLast = index === items.length - 1;
            const name = typeof item === "string" ? item : item.name;
            const id = typeof item === "string" ? item : item?.uid;

            return (
              <motion.li
                key={id || name}
                initial={{ opacity: 0, y: 5 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                className="flex items-center">
                {index !== 0 && <i className="fa-solid fa-chevron-right text-xs text-gray-400 mx-2"></i>}

                {isLast ? (
                  <span className="text-primary font-semibold">{name}</span>
                ) : (
                  <button
                    onClick={() => onNavigate?.(item, index)}
                    className="text-gray-500 hover:text-primary transition-colors">
                    {name}
                  </button>
                )}
              </motion.li>
            );
          })
        )}
      </ol>
    </nav>
  );
}
